import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=script&setup=true&lang=js"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=script&setup=true&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Dashboard.vue?vue&type=script&setup=true&lang=js
// module id = 801
// module chunks = 31